<template>
  <div>
    <van-loading type="spinner" v-if="nodata"/>
    <div style="background: #ffffff;border-bottom: 3px solid #777777;"  v-if="dominItem.templateId === 'temp1'">
      <div class="logo">
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%">
          <span>{{ dominItem.logoName || 'Logo' }}</span>
          <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId" color="#ffffff"></topIcon>
        </div>
      </div>
      <div class="category" >
            <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
                item.label
              }}</span>
      </div>
    </div>
    <div style="background: #ffffff;border-bottom: 3px solid #777777;"  v-if="dominItem.templateId === 'temp2'">
      <div class="category" >
            <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
                item.label
              }}</span>
      </div>
      <div class="logo">
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%">
          <span>{{ dominItem.logoName || 'Logo' }}</span>
          <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId" color="#ffffff"></topIcon>
        </div>
      </div>

    </div>
    <div style="background: #ffffff;border-bottom: 3px solid #777777;"  v-if="dominItem.templateId === 'temp3'">
      <div class="logo">
        <div style="display: flex; align-items: center; justify-content: space-between; width: 100%">
          <span>{{ dominItem.logoName || 'Logo' }}</span>
          <topIcon :template="dominItem.templateId" :nationId="dominItem.nationId" color="#ffffff"></topIcon>
        </div>
      </div>
      <div class="category" style="  display: flex;
  justify-content: center;">
            <span v-for="item in typeList" @click="changeType(item.id)" :class="[{ choose: current === item.id }]">{{
                item.label
              }}</span>
      </div>


    </div>

    <div style="width: 70%; margin: auto">
      <div class="news-page">
        <!-- 左侧主要新闻区域 -->
        <div class="main-news">
          <h1 class="main-title" @click="toDetail(bestItem.articleShortName)">{{ bestItem.articleTitle }}</h1>
          <img
              :src="bestItem.articleImage"
              class="main-image"
              @click="toDetail(bestItem.articleShortName)"
          />


          <h3 class="section-title"><span class="section-tag">{{ $t('con_latest') }}</span></h3>

          <div v-for="item in articleList" style="border-bottom: 1px solid #CACACA; margin-bottom: 15px"
               @click="toDetail(item.articleShortName)">
          <h2 class="sub-title twoHde" style="margin-left: 0">{{ item.articleTitle }}</h2>
          <p class="sub-desc threeHde"  style="margin-left: 0">
            {{ item.articleIntro }}
          </p>
          </div>
        </div>
        <!-- 右侧国际新闻区域 -->
        <div class="international-news">
          <h3 class="section-title"><span class="section-tag">{{ $t('con_bestnew') }}</span></h3>
          <div class="news-item" v-for="item in articleList1" @click="toDetail(item.articleShortName)">
            <h4 class="news-title twoHde" style="margin-left: 0">{{ item.articleTitle }}</h4>
            <div style="display: flex; border-bottom: 1px solid #CACACA; ">
            <img
                :src="item.articleImage"
                class="news-image"
            />
            <p class="news-desc fiveHde">
              {{ item.articleIntro }}
            </p>
            </div>
          </div>
        </div>
      </div>
      <h3 class="section-title"><span class="section-tag">{{ $t('con_hot_con') }}</span></h3>
      <div class="but-box">
        <div v-for="item in articleList2" style="border-bottom: 1px solid #CACACA; margin-bottom: 15px" @click="toDetail(item.articleShortName)">
          <h2 class="sub-title twoHde" style="margin-left: 0">{{ item.articleTitle }}</h2>

          <img :src="item.articleImage" class="but-img" alt="">
          
          <p class="sub-desc threeHde"  style="margin-left: 0">
            {{ item.articleIntro }}
          </p>
        </div>
      </div>

    </div>
    <div class="buttom" style="margin-top: 20px">
      <div class="explore">
        <span v-for="item in typeList" @click="changeType(item.id)" style="cursor: pointer; color: #000000">{{ item.label }}</span>
      </div>
      <div class="logo" style="color: #3B5998;">{{ dominItem.logoName || 'Logo' }}</div>
      <footers is00="is03"  :articleListlast="articleListlast" :current="current"></footers>
    </div>
  </div>
</template>

<script>
import {getOne, newContent} from "@/api"
import topIcon from '../../icons/iconblick.vue'
import {format} from "date-fns";
import buttomIcon from '../../icons/big.vue'
import footers from "@/components/footContent/index.vue"

export default {
  components: {topIcon, buttomIcon, footers},


  props: {
    dominItem: Object
  },

  name: "index",
  data() {
    return {
      bestItem: {},
      nodata: false,
      // template: 'temp3',
      current: 1,
      recommendList: [],
      latestNewsList: [],
      articleList: [],
      articleList1: [],
      articleList2: [],
      articleList3: [],
      articleList4: [],
      articleListlast: [],
      recommendList1: [],
      typeList: [
        {label: this.$t('con_AllPRESS'), id: 4},
        {label: this.$t('con_home'), id: 1},
        {label: this.$t('con_AUTO'), id: 6},
        {label: this.$t('con_NEWS'), id: 3},
        {label: this.$t('con_BUSINESS'), id: 2},
        {label: this.$t('con_TECHNOLOGY'), id: 7},
        {label: this.$t('con_LIFESTYLE'), id: 5},
      ],
      iconListsmall: [
        {url: require('../../../assets/icon/linkedin.png'), link: 'https://www.linkedin.cn/'},
        {url: require('../../../assets/icon/facebook.png'), link: 'https://www.facebook.com/'},
        {url: require('../../../assets/icon/flipboard.png'), link: 'https://www.flipboard.cn/'},
        {url: require('../../../assets/icon/twitter.png'), link: 'https://twitter.com/'},
        {url: require('../../../assets/icon/instagram.png'), link: 'https://www.instagram.com/'},
      ],
    }
  },
  created() {
    this.nationId = JSON.parse(localStorage.getItem('dominItem')).nationId


    if (this.$route.query.type) {
      this.changeType(Number(this.$route.query.type))
    } else {
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    }
  },

  methods: {
    openLink(link) {
      window.open(link)
    },
    changeType(item) {
      if (item === 8) {
        item = 1
      }
      this.nodata = true
      this.current = item
      this.getArticleList()
      this.getArticleListlast()
      this.getLatestNewsList()
      this.getRecommendList()
      this.getRecommendList1()
      this.getRecommendList2()
      this.getOneList()
    },

    // 获取最新的一篇文章
    getOneList() {
      getOne({articleCategoryId: this.current, articleNationId: this.dominItem.nationId}).then(res => {
        if (!res.data.articleImage) {
          res.data.articleImage = require('@/assets/defore.jpg')
        }
        this.bestItem = res.data
        this.bestInfo.uploadTime = format(new Date(this.bestInfo.uploadTime), this.$t('con_format'))
      })
    },


    // 获取推荐文章列表
    getArticleList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 10,
        articleNationId: this.nationId,
        articleType: 'con_recommended'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList = res.rows
        this.nodata = false
      })
    },


    // 获取最新文章
    getLatestNewsList() {
      newContent({
        articleCategoryId: this.current,
        pageNum: this.newsPageNum,
        pageSize: 8,
        articleNationId: this.nationId,
        articleType: 'con_latest'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList1 = res.rows
        this.newsTotal = res.total
      })
    },

    //  获取热门文章
    getRecommendList() {
      newContent({
        articleCategoryId: this.current, pageNum: this.recommendPageNum, pageSize: 9,

        articleNationId: this.nationId, articleType: 'con_hot_con'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList2 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList1() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 12,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList3 = res.rows
      })
    },

    // 获取最新推荐
    getRecommendList2() {
      newContent({
        articleCategoryId: this.current,
        pageNum: 1,
        pageSize: 9,
        articleNationId: this.nationId,
        articleType: 'con_bestnew'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleList4 = res.rows
      })
    },

    // 获取最下面文章列表  相关文章
    getArticleListlast() {
      // this.nodata = true
      newContent({
        articleCategoryId: this.current,
        pageNum: 3,
        pageSize: 6,
        articleNationId: this.nationId,
        articleType: 'con_related'
      }).then(res => {
        res.rows.map(r => {
          r.uploadTime = format(new Date(r.uploadTime), this.$t('con_format'))
          if (!r.articleImage) {
            r.articleImage = require('@/assets/defore.jpg')
          }
        })
        this.articleListlast = res.rows
        this.nodata = false
      })
    },

    //  查看详情
    toDetail(name) {
      this.$router.push(`/details/${name}?type=${this.current}`)
    }
  }
};
</script>

<style scoped lang="scss">
.section-title {
  font-size: 22px;
  margin-bottom: 15px;
}

.section-tag {
  background-color: #333;
  color: #fff;
  padding: 2px 5px;
  font-size: 14px;
  margin-left: 5px;
}

.sub-title {
  font-size: 20px;
  margin-bottom: 5px;
}
.sub-title:hover{
  color: #14689F;
  cursor: pointer;
}

.sub-desc {
  font-size: 16px;
  margin-bottom: 15px;
}
.news-page {
  color: #444444;
    display: flex;
    justify-content: space-between;
    padding: 20px 0;

  .main-news {
    flex: 2;
    margin-right: 20px;
  }

  .main-title {
    font-size: 24px;
    font-weight: bold;

    margin-bottom: 10px;
  }

  .main-title:hover{
    color: #14689F;
    cursor: pointer;
  }

  .main-image {
    width: 100%;
    height: 400px;
    object-fit: cover;
    margin-bottom: 10px;
  }


  .international-news {
    flex: 1;
  }



  .news-item {
    margin-bottom: 20px;
  }

  .news-title {
    font-size: 18px;
    margin-bottom: 5px;
  }

  .news-title:hover, .sub-title:hover{
    color: #14689F;
    cursor: pointer;
  }

  .news-image {
    width: 150px;
    height: 150px;
    object-fit: cover;
    border-radius: 10px;
    margin-right: 10px;
  }

  .news-desc {
    height: 100px;
    font-size: 14px;
    margin-top: 10px;
  }
}

.but-box {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 30px;

  .but-img {
    width: 100%;
    height: 200px;
    margin: 10px 0;
    border-radius: 10px;
    object-fit: cover;
  }
}


.logo {
  width: 85%;
  margin-left: 15%;
  padding: 10px 0;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  font-size: 30px;
  color: #215581;
  justify-content: space-between;
  font-weight: bold;
  text-align: left;
}

.logo-temp1 {
  padding: 0 20px 0 15%;
}

.logo-temp2 {
}

.category {
  width: 70%;
  margin: 20px auto 5px;
  min-height: 40px;
  //margin-bottom: 30px;
  color: #215581;

  font-weight: 700;
  //border-top: 2px solid var(--themeColor);
  //border-bottom: 2px solid #E6E8EA;
  line-height: 38px;

  span {
    font-weight: 500;
    font-size: 18px;
    display: inline-block;
    padding: 0 10px;
    cursor: pointer;
    position: relative;
    //border-bottom: 3px solid #ffffff;
  }

  span:hover {
    //border-bottom: 3px solid red;
    border-radius: 5px;
    background: #215581;
    color: #ffffff;
    transition: all .1s ease;
  }

  .choose {
    transition: all .1s ease;
    background: #215581;
    border-radius: 5px;
    color: #ffffff;
    //border-bottom: 3px solid #000000;
  }
}

.buttom {
  background: #ffffff;
  border-top: 2px solid #000000;
  display: flex;
  flex-direction: column;

  .logo {
    width: 80%;
    margin: auto;
    font-size: 20px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
  }

  display: flex;

  .explore {
    display: flex;
    justify-content: center;
    margin-top: 30px;
    align-items: center;
    span {
      margin-right: 10px;
      font-size: 15px;
    }

    span:hover{
      color: #3B5998 !important;
    }
  }
}

.about {
  cursor: pointer;
  height: 40px;
  line-height: 40px;
  font-weight: 400;
  font-size: 17px;
  text-transform: uppercase;
  display: flex;
  justify-content: end;
  //justify-content: space-between;
  padding-right: 20px;
  color: #000000;
  align-items: center;

  span {
    margin-left: 20px;
    margin-right: 20px;
  }

  img {
    width: 20px;
    height: 20px;
  }

  img:nth-child(4) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(5) {
    width: 30px;
    height: 30px;
  }

  img:nth-child(6) {
    width: 30px;
    height: 30px;
  }
}


.content {
  display: flex;
  flex-wrap: wrap;

  span {
    display: inline-block;
    margin-bottom: 10px;
    width: 50%;
  }
}

.imgsss {
  width: 30px;
  height: 30px;
}

.imgsss:nth-child(4) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(5) {
  width: 40px;
  height: 40px;
}

.imgsss:nth-child(3) {
  width: 40px;
  height: 40px;
}

.article-image1 {
  width: 80px;
  height: 80px;
  object-fit: cover;
}

.bgSpan {
  color: #ffffff;
  border-radius: 5px;
  border: 1px solid red;
  display: inline-block;
  padding: 5px 10px;
  background: #E2001A;
}

</style>